// extracted by mini-css-extract-plugin
export default {"custom-autocomplete":"custom-autocomplete_custom-autocomplete__KAAq2"};